import { useRef, useEffect, useCallback } from 'react';
import { isLocalDev } from '../utils/environment';

export default function useAbortController() {
    const abortControllerRef = useRef(null); // Initialize with null

    // Use a useCallback for the abort function to prevent unnecessary re-creations
    const abort = useCallback(() => {
        if (abortControllerRef.current) {
            if (isLocalDev) {
                console.log('1.Aborting request with AbortController');
            }
            abortControllerRef.current.abort();
            // Optional: Re-create a new controller if you plan to make new requests
            // after aborting and before component unmounts.
            // If the component won't re-mount, this isn't strictly necessary.
            // abortControllerRef.current = new AbortController();
        }
    }, []); // No dependencies, as it only operates on the ref

    // useEffect to manage the AbortController lifecycle
    useEffect(() => {
        // Initialize the controller when the component mounts
        abortControllerRef.current = new AbortController();

        // Cleanup function: Abort any pending requests when the component unmounts
        return () => {
            if (abortControllerRef.current) {
                if (isLocalDev) {
                    console.log('2.Aborting request with AbortController');
                }
                // Check if it hasn't already been aborted by an explicit 'abort' call
                // and if the signal is still relevant.
                // It's safer to just abort unconditionally here for cleanup.
                abortControllerRef.current.abort();
            }
        };
    }, []); // Empty dependency array means this runs only once on mount and once on unmount

    // If abortControllerRef.current can be null initially, provide a fallback.
    // However, with useEffect, it should be initialized by the time components render.
    // A safer way is to return the signal directly from the ref.
    const signal = abortControllerRef.current ? abortControllerRef.current.signal : null;

    return [signal, abort];
}